// extracted by mini-css-extract-plugin
export default {"app":"app_app__WbPPF","custom-scroll":"app_custom-scroll__HiG4n","snackbar":"app_snackbar__xGoJi"};